export enum StageTypes {
  DEVELOPMENT = 'development',
  TEST = 'test',
  PRODUCTION = 'production',
}

export const EnvironmentHelper = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const isLocalhost = window.location.host.indexOf('localhost:') > -1;
  const isDevelopment = process.env.REACT_APP_ENVIRONMENT === StageTypes.DEVELOPMENT;
  const isProduction = process.env.REACT_APP_ENVIRONMENT === StageTypes.PRODUCTION;
  const isTest = process.env.REACT_APP_ENVIRONMENT === StageTypes.TEST;
  const hasURLTestEnvironment = window?.location?.host?.split('.').length > 3; //example : neo.toy-env.fitogram.pro
  return {
    environment,
    isLocalhost,
    isDevelopment,
    isProduction,
    isTest,
    hasURLTestEnvironment,
  };
};
